import React from "react";

import { DetailItemType } from "../types";
import { ListItem } from ".";

interface Props {
  items: DetailItemType[];
}

const ItemsList: React.FC<Props> = ({ items }) => {
  if (!items?.length) return null;

  return (
    <ul className="mb-8 pl-0 last:mb-0">
      {items.map((item) => (
        <ListItem key={item.id} {...item} />
      ))}
    </ul>
  );
};

export default ItemsList;
